import script from "./RequestForm.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestForm.vue?vue&type=script&setup=true&lang=js"

import "./RequestForm.vue?vue&type=style&index=0&id=7b4f2bf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b4f2bf4"]])

export default __exports__